
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, GetParticipantSourceDataStatuses, QuerySourceDataStatusesResponse, Participant, SourceDataStatus } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<QuerySourceDataStatusesResponse, QuerySourceDataStatusesResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<QuerySourceDataStatusesResponse, QuerySourceDataStatusesResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<QuerySourceDataStatusesResponse, QuerySourceDataStatusesResponse>) => ({
    idMap: response?.data?.data?.reduce<Record<number, SourceDataStatus>>((a, b) => {
        if (!b?.participantId) {
            return a;
        }
        
        a[b.participantId] = b;

        return a;
    },{})
});

export const useParticipantStatuses = (trialId?: number, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!trialId) {
            return undefined;
        }

        return () => {
            return new GetParticipantSourceDataStatuses({ trialId });
        }
    }, [trialId]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useParticipantStatuses;